module.exports = __webpack_public_path__ + "static/asset-store-badge-ebd14669ac914fd0a10aac8657d03324.png";